import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { adminRoute, publicAdminRoutes, privateAdminRoutes, userRoute } from './utils/constants/route';
import { AdminMainLayout } from './layouts';
import { ToastContainer } from 'react-toastify';
import { CallProvider } from '~/context/CallContext';
import GlobalCallManager from '~/call/GlobalCallManager';
import { CALL_TOAST_CONTAINER_ID } from '~/utils/helper';
import 'mapbox-gl/dist/mapbox-gl.css';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <CallProvider>
        <Routes>
        {/* Admin public route */}
        <Route path={userRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base}>
          {publicAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        {/* Private route */}
        <Route path={adminRoute.base} element={<AdminMainLayout />}>
          {privateAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        </Routes>
        <GlobalCallManager />
        <ToastContainer newestOnTop autoClose={5000} theme='light' limit={1} />
        <ToastContainer
          containerId={CALL_TOAST_CONTAINER_ID}
          position='top-right'
          newestOnTop
          autoClose={5000}
          theme='light'
          limit={8}
          style={{ top: 72 }}
        />
      </CallProvider>
    </BrowserRouter>
  );
};

export default App;
